import React, { Fragment } from "react";
import CustomPropTypes from "../utils/customPropTypes";
import PropTypes from "prop-types";
import SafeHTML from "./SafeHTML";
import style from '../../scss/components/VideoBlock';
export default class VideoBlock extends React.Component {
    static propTypes = {
        uploadVideo: CustomPropTypes.Document,
        externalUrl: PropTypes.string,
        embedCode: PropTypes.string
    };
    getVideoHTML = () => {
        if (this.props.externalUrl) {
            return <iframe width="100%" height="100%" src={this.props.externalUrl}>
            </iframe>
        }
        else if (this.props.uploadVideo) {
            return <video width="100%" height="100%" className="object-embed" controls>
                <source src={this.props.uploadVideo.url} />
                Your browser does not support the video tag.
                    </video>

        }
        else if (this.props.embedCode) {
            return <SafeHTML>{this.props.embedCode}</SafeHTML>
        }
    }
    render() {
        return (<div className="video-object">{this.getVideoHTML()}</div>);
    }
}
